/**
 * Formats a numeric ticket ID into the display format T-XXXXX.
 * The numeric part is zero-padded to 5 digits.
 *
 * @example formatTicketId(34)  // "T-00034"
 * @example formatTicketId(123) // "T-00123"
 */
export function formatTicketId(id: number | string): string {
  return `T-${String(id).padStart(5, '0')}`
}
